var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPhone = function SvgPhone(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 14
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.808 7.45a.94.94 0 0 0-1.095.267l-.778.952a7.2 7.2 0 0 1-2.604-2.604l.95-.776a.934.934 0 0 0 .267-1.094L5.423 1.57a.936.936 0 0 0-1.057-.549l-2.625.563A.936.936 0 0 0 1 2.5c0 5.419 4.106 9.881 9.377 10.442q.344.036.694.051h.002q.214.009.427.01c.443 0 .825-.31.916-.741l.563-2.625a.936.936 0 0 0-.548-1.057L9.805 7.455zm1.54 4.425c-5.056-.082-9.141-4.167-9.22-9.222l2.324-.5L5.46 4.506l-.841.69c-.427.349-.537.956-.26 1.434a8.3 8.3 0 0 0 3.014 3.014 1.125 1.125 0 0 0 1.434-.26l.69-.842 2.352 1.008z"
  })));
};
export default SvgPhone;